import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { class: "evaluation" }

import { computed, Component, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

import { PanelTheme } from "../";

import {
  baseInput,
  baseConfirm,
  baseSelect,
  svgIcon,
  tabMenu,
  iconMenu,
  cardEvaluation,
} from "@/common/components";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'cockpit',
  props: {
    accountId: {},
    evaluationId: {},
    evaluation: {},
    evaluations: {},
    tabList: {},
    menuList: {},
    isEdit: { type: Boolean }
  },
  emits: [
  "update-data",
  "add",
  "input-search",
  "search",
  "select-tab",
  "change-status",
],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const router = useRouter();

const emit = __emit;

const props = __props;

const searchInput = ref("");

const selectedTab = ref<string | null>(null);
const statusType = ref("PROGRESS");

const statusOptions = computed(() => [
  {
    option: t("evaluation.labels.in_progress"),
    value: "PROGRESS",
  },
  {
    option: t("evaluation.labels.started"),
    value: "STARTED",
  },
  {
    option: t("evaluation.labels.pending"),
    value: "PENDING",
  },
  {
    option: t("evaluation.labels.concluded"),
    value: "CONCLUDED",
  },
  {
    option: t("evaluation.labels.canceled"),
    value: "CANCELED",
  },
]);

function selectTab(tab: string) {
  selectedTab.value = tab;
  emit("update-data");
}

function selectEvaluation(evaluation_id: string) {
  router.push(`/${props.accountId}/cockpit/${evaluation_id}`);
  setTimeout(() => selectTab("info"), 100);
}

function back() {
  router.push(`/${props.accountId}/cockpit`);
}

onMounted(() => {
  const status = localStorage.getItem("cockpit-status");
  statusType.value = status || "PROGRESS";

  selectTab("info");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelTheme), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(baseSelect), {
          modelValue: statusType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusType).value = $event)),
          value: statusType.value,
          options: statusOptions.value,
          "is-empty": false,
          disabled: true
        }, null, 8, ["modelValue", "value", "options"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(baseInput), {
            modelValue: searchInput.value,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((searchInput).value = $event)),
              _cache[3] || (_cache[3] = ($event: any) => (emit('input-search', searchInput.value)))
            ],
            background: "#fff",
            color: "#000",
            placeholder: _unref(t)('common.labels.search'),
            "onKey:enter": _cache[4] || (_cache[4] = ($event: any) => (emit('search', searchInput.value)))
          }, {
            sufix: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(svgIcon), {
                  icon: "search",
                  size: "1.75rem",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('search', searchInput.value)))
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-md btn-primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('add')))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "add",
              size: "1.1rem"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.evaluation")?.toUpperCase()), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-md btn-back",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1.25rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.evaluations, (item) => {
            return (_openBlock(), _createBlock(_unref(cardEvaluation), {
              key: item.evaluation_id,
              "avatar-size": "4rem",
              evaluation: item,
              active: item.evaluation_id === __props.evaluationId,
              "show-progress": false,
              "show-arrow": true,
              onClick: ($event: any) => (selectEvaluation(item.evaluation_id))
            }, null, 8, ["evaluation", "active", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(tabMenu), {
            tabs: __props.menuList,
            active: selectedTab.value,
            "onSelect:tab": _cache[8] || (_cache[8] = ($event: any) => (selectTab($event)))
          }, {
            content: _withCtx(() => [
              (selectedTab.value)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tabList[selectedTab.value]?.component), {
                    key: 0,
                    "is-edit": __props.isEdit,
                    "account-id": __props.accountId,
                    "evaluation-id": __props.evaluationId,
                    data: __props.evaluation,
                    onUpdateData: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update-data')))
                  }, null, 40, ["is-edit", "account-id", "evaluation-id", "data"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["tabs", "active"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})